import React from 'react';
import { Outlet } from 'react-router-dom';
import { PAGE_TYPE, SideNavContainer, withModalWrapper } from '../members/utils';
import { modalConfig } from './modals/modalConfig';
import { StyledContainer } from './ResetPasswordStyles';

const ResetPasswordContainer = () => {
    return (
        <SideNavContainer page={PAGE_TYPE.RESET_PASSWORD_PAGE}>
            <StyledContainer className="desktop:grid-col-9 reset-password-container" id="main-content">
                <Outlet />
            </StyledContainer>
        </SideNavContainer>
    );
};

export default withModalWrapper(ResetPasswordContainer, modalConfig);
